<template>
  <v-dialog persistent v-model="dialog" fullscreen>
    <v-card>
      <v-card-title>
        Kampanya Oluştur
        <v-spacer></v-spacer>
        <v-btn @click="dialog = false" color="danger darken-1" style="color: white;">
          KAPAT
        </v-btn>
      </v-card-title>
      <v-card-text>
        <div class="container-fluid">
          <div class="row">
            <div class="col-lg-6">
              <div class="row">
                <div class="col-lg-6">
                  <v-select
                      v-model="currentType"
                      label="Cari Tipi"
                      :error-messages="
                      validationMessages(
                        $v.currentType,
                        'Cari Tipi'
                      )
                    "
                      @input="$v.currentType.$touch()"
                      @blur="$v.currentType.$touch()"
                      :items="[
                      { value: 1, text: 'Tüm Cariler' },
                      { value: 2, text: 'Cari Kodu' },
                      { value: 3, text: 'Grup Kodu' },
                      { value: 4, text: 'Kod1 Kodu' },
                      { value: 5, text: 'Kod2 Kodu' },
                      { value: 6, text: 'Kod3 Kodu' },
                      { value: 7, text: 'Kod4 Kodu' },
                      { value: 8, text: 'Kod5 Kodu' },
                    ]"
                      item-text="text"
                      item-value="value"
                      dense
                      filled
                      solo
                      placeholder=" "
                      clearable
                      @change="(e) => currentTypeValueChange(e)"
                  >
                  </v-select>
                </div>
                <div class="col-lg-6">
                  <search-select
                      v-if="currentType === 2"
                      :search-type="'current'"
                      @itemChange="(e) => (currentKey = e)"
                      :label="'Cari Veri'"
                  >
                  </search-select>
                  <v-select
                      v-model="currentKey"
                      label="Cari Veri"
                      :items="currentCodesListResult"
                      item-value="code"
                      item-text="name"
                      dense
                      filled
                      solo
                      placeholder=" "
                      clearable
                      hide-details
                      v-if="
                      currentType !== 1 &&
                        currentType !== 2 &&
                        currentType != null
                    "
                  >
                  </v-select>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="row">
                <div class="col-lg-4">
                  <v-select
                      v-model="stockType"
                      label="Stok Tipi"
                      :error-messages="
                      validationMessages($v.stockType, 'Stock Tipi')
                    "
                      :items="[
                      { value: 1, text: 'Tüm Stoklar' },
                      { value: 2, text: 'Stok Kodu' },
                      { value: 3, text: 'Grup Kodu' },
                      { value: 4, text: 'Kod 1' },
                      { value: 5, text: 'Kod 2' },
                      { value: 6, text: 'Kod 3' },
                      { value: 7, text: 'Kod 4' },
                      { value: 8, text: 'Kod 5' },
                    ]"
                      item-text="text"
                      item-value="value"
                      dense
                      filled
                      solo
                      placeholder=" "
                      @input="$v.stockType.$touch()"
                      @blur="$v.stockType.$touch()"
                      clearable
                  >
                  </v-select>
                </div>
                <div class="col-lg-8">
                  <v-select
                      v-if="stockType===3"
                      v-model="stockKey"
                      label="Grup Kodu"
                      :items="groupCodeList"
                      item-text="name"
                      item-value="code"
                      filled
                      solo
                      dense
                      clearable
                  >
                  </v-select>
                  <search-select
                      v-if="stockType === 2"
                      :search-type="'stock'"
                      @itemChange="(e) => (stockKey = e)"
                      :label="'Stok Veri'"
                  >
                  </search-select>
                  <search-select
                      :present-items="stockCodesListResult"
                      v-if="
                      stockType !== 1 &&
                        stockType !== 2 &&
                        stockType !== 3 &&
                        stockType != null
                    "
                      :search-type="'withData'"
                      @itemChange="(e) => (stockKey = e)"
                      :label="'Stok Veri'"
                  >
                  </search-select>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <v-select
                  v-model="valueType1"
                  label="İndirim Tipi"
                  :items="[
                  { value: 1, text: 'Oran (Yüzde: %)' },
                  { value: 2, text: 'Tutar (Fiyat: TRY)' },
                ]"
                  item-text="text"
                  item-value="value"
                  dense
                  filled
                  solo
                  placeholder=" "
                  clearable
                  hide-details
              >
              </v-select>
            </div>
            <div class="col-lg-6">
              <v-text-field
                  v-model="valueKey1"
                  label="İndirim Veri"
                  dense
                  filled
                  solo
                  placeholder="Lütfen seçtiğiniz indirim tipine göre veri girin."
                  :error-messages="
                  validationMessages($v.valueKey1, 'İndirim Veri')
                "
                  persistent-placeholder
                  clearable
                  hide-details
              >
              </v-text-field>
            </div>
            <div class="col-lg-6">
              <v-select
                  v-model="valueType2"
                  label="İndirim Tipi 2"
                  :items="[
                  { value: 1, text: 'Oran (Yüzde: %)' },
                  { value: 2, text: 'Tutar (Fiyat: TRY)' },
                ]"
                  item-text="text"
                  item-value="value"
                  dense
                  filled
                  solo
                  placeholder=" "
                  clearable
                  hide-details
              >
              </v-select>
            </div>
            <div class="col-lg-6">
              <v-text-field
                  v-model="valueKey2"
                  label="İndirim Veri 2"
                  dense
                  filled
                  solo
                  placeholder="Lütfen seçtiğiniz indirim tipine göre veri girin."
                  persistent-placeholder
                  clearable
                  hide-details
              >
              </v-text-field>
            </div>
            <div class="col-lg-6">
              <v-menu
                  transition="scale-transition"
                  offset-y
                  :close-on-content-click="false"
                  min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      :value="formattedDate(startDate)"
                      label="Tarih Aralık Başlangıç"
                      prepend-inner-icon="mdi-calendar"
                      readonly
                      dense
                      filled
                      solo
                      placeholder=" "
                      clearable
                      @click:clear="startDate = null"
                      v-bind="attrs"
                      v-on="on"
                      :error-messages="
                      validationMessages($v.startDate, 'Başlangıç Tarihi')
                    "
                  ></v-text-field>
                </template>
                <v-date-picker v-model="startDate" locale="tr"></v-date-picker>
              </v-menu>
            </div>
            <div class="col-lg-6">
              <v-menu
                  transition="scale-transition"
                  offset-y
                  :close-on-content-click="false"
                  min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      :value="formattedDate(finishDate)"
                      label="Tarih Aralık Bitiş"
                      prepend-inner-icon="mdi-calendar"
                      readonly
                      dense
                      filled
                      solo
                      placeholder=" "
                      clearable
                      @click:clear="finishDate = null"
                      v-bind="attrs"
                      v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="finishDate" locale="tr"></v-date-picker>
              </v-menu>
            </div>
            <div class="col-lg-3">
              <v-text-field
                  v-model="description"
                  label="Açıklama"
                  dense
                  filled
                  solo
                  clearable
                  hide-details
              >
              </v-text-field>
            </div>
            <div class="col-lg-3">
              <v-select
                  v-model="isActive"
                  label="Durum"
                  dense
                  filled
                  solo
                  clearable
                  hide-details
                  :items="[
                  { value: true, text: 'Aktif' },
                  { value: false, text: 'Pasif' },
                ]"
                  item-value="value"
                  item-text="text"
              >
              </v-select>
            </div>
          </div>
        </div>
        <hr/>
        <div class="d-flex">
          <v-spacer></v-spacer>
          <v-btn small class="me-1" color="secondary" @click="dialog = false"
          >İptal Et
          </v-btn
          >
          <v-btn small color="success" @click="saveBasket"
          >Oluştur
          </v-btn
          >
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import {mapActions, mapState} from "vuex";
import {formattedDate} from "@/momentHelper";
import {required} from "vuelidate/lib/validators";
import {validationMixin} from "vuelidate";
import {validationMessages} from "@/validationMessages";
import SearchSelect from "@/components/searchSelect.vue";
import {showProcessErrorMessage} from "@/state/alertHelpers";
// {showProcessPromptMessage,showProcessSuccessMessage, showProcessErrorMessage} from "@/state/alertHelpers";

export default {
  mixins: [validationMixin],

  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    stockBasketId: {
      type: Number,
      default: null,
    },
    processType: {
      type: String,
      default: "new",
    },
  },
  components: {SearchSelect},
  computed: {
    ...mapState("current", ["salesPersonList"]),
    ...mapState("basket", ["basketCategoryList"]),
    ...mapState("auth", ["user"]),
  },
  mounted() {
    this.getCodesList();
    this.fetchSalesPersonList({
      params: {},
      body: {},
    });
  },
  validations() {
    return {
      startDate: {required},
      valueKey1: {required},
      currentType: {required},
      stockType: {required},
    };
  },
  data() {
    return {
      dialog: false,
      currentSearchText: "",
      currentSearchLoading: false,
      currentSearchResult: [],
      searchCurrentTimeout: null,
      selectedCurrent: null,
      currentKey: null,
      currentCodesListResult: [],
      currentType: null,
      stockSearchText: "",
      stockSearchLoading: false,
      stockSearchResult: [],
      searchStockTimeout: null,
      selectedStock: null,
      stockKey: null,
      stockCodesListResult: [],
      stockType: null,
      startDate: null,
      finishDate: null,
      isActive: null,
      description: null,
      valueType1: null,
      valueKey1: null,
      valueType2: null,
      valueKey2: null,
      extraPriceValueType: null,
      extraPriceValueKey: null,
      groupCodeList: [],
      groupCodeList1: [],
      groupCodeList2: [],
      groupCodeList3: [],
      groupCodeList4: [],
      groupCodeList5: [],
      groupCodeValue: null,
      groupCodeValue1: null,
      groupCodeValue2: null,
      groupCodeValue3: null,
      groupCodeValue4: null,
      groupCodeValue5: null,
    };
  },
  methods: {
    validationMessages,
    formattedDate,
    ...mapActions("current", [
      "fetchSalesPersonList",
      "fetchCurrentCodesList",
      "fetchCurrentList",
    ]),
    ...mapActions("basket", [
      "stockBasketAdd",
      "fetchStockBasketSingle",
      "stockBasketUpdate",
    ]),
    ...mapActions("stock", ["fetchStockList", "fetchStockCodes"]),
    async _fetchCurrentList(searchText) {
      this.currentSearchResult = await this.fetchCurrentList({
        params: {
          userId: this.user.UserId,
          pageNumber: 1,
          pageSize: 50,
          ...(this.user.RoleGroupId == "2" || this.user.RoleGroupId == 2 ? true : false) && {salesPersonCode: this.user.SalesPersonCode},
          ...(!(searchText === "" || searchText == null) && {
            searchText: searchText,
          }),
        },
        body: {},
        loading: false,
      });
      this.currentSearchLoading = false;
    },
    async _fetchCurrentCodesList(tableType) {
      this.currentCodesListResult = await this.fetchCurrentCodesList({
        params: {
          tableType: tableType,
        },
        body: {},
        loading: false,
      });
    },
    async _fetchStockCodes(tableType) {
      this.stockCodesListResult = await this.fetchStockCodes({
        params: {
          tableType: tableType,
        },
        body: {},
        loading: false,
      });
    },
    _currentSearchText: function (searchText) {
      if (searchText && searchText.length > 4) {
        this.currentSearchResult = [];
        if (this.searchCurrentTimeout) clearTimeout(this.searchCurrentTimeout);
        this.currentSearchLoading = true;
        this.searchCurrentTimeout = setTimeout(() => {
          this._fetchCurrentList(searchText);
        }, 2000);
      }
    },
    _stockSearchText: function (searchText) {
      if (searchText && searchText.length > 4) {
        this.stockSearchResult = [];
        if (this.searchStockTimeout) clearTimeout(this.searchStockTimeout);
        this.stockSearchLoading = true;
        this.searchStockTimeout = setTimeout(() => {
          this._fetchStockList(searchText);
        }, 2000);
      }
    },
    currentTypeValueChange(value) {
      this.currentCodesListResult = [];
      switch (value) {
        case 1:
          // this._fetchCurrentCodesList(index,value)
          break;
        case 2:
          //  this._fetchCurrentCodesList(index,value)
          break;
        case 3:
          this._fetchCurrentCodesList(value - 2);
          break;
        case 4:
          this._fetchCurrentCodesList(value - 2);
          break;
        case 5:
          this._fetchCurrentCodesList(value - 2);
          break;
        case 6:
          this._fetchCurrentCodesList(value - 2);
          break;
        case 7:
          this._fetchCurrentCodesList(value - 2);
          break;
        case 8:
          this._fetchCurrentCodesList(value - 2);
          break;
      }
    },
    async _fetchStockList(searchText) {
      this.stockSearchResult = await this.fetchStockList({
        params: {
          pageNumber: 1,
          pageSize: 30,
          userId: this.user.UserId,
        },
        body: {
          stock: searchText,
          GenericCategories: null,
        },
        onlyData: true,
        loading: false,
      });
      this.stockSearchLoading = false;
    },

    async saveBasket() {
      if (this.valueKey2 && !this.valueType2) {
        showProcessErrorMessage({
          title: "Hata",
          text: "İkinci indirim tipi seçildiğinde indirim verisi de seçilmelidir",
        });
        return;
      }
      if (this.processType === 'new')
        await this._stockBasketAdd();
      else
        await this._stockBasketUpdate()
    },

    async _stockBasketUpdate() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        await this.stockBasketUpdate({
          params: {
            userId: this.user.UserId,
          },
          body: {
            id: this.stockBasketId,
            startDate: this.startDate,
            finishDate: this.finishDate,
            description: this.description,
            stockType: this.stockType,
            stockKey: this.stockKey,
            currentType: this.currentType,
            currentKey: this.currentKey,
            valueType1: this.valueType1,
            valueKey1: this.valueKey1,
            valueType2: this.valueType2,
            valueKey2: this.valueKey2,
            isActive: this.isActive,
          },
        });
        this.$emit("editdone");
          this.dialog = false;
      }
    },

    async getCodesList() {
      let codeList = [1, 2, 3, 4, 5, 6];
      for (let i = 0; i < codeList.length; i++) {
        let requestParams = {};
        requestParams.params = {tableType: codeList[i]};
        requestParams.body = {}
        let result = await this.fetchStockCodes(requestParams);
        switch (codeList[i]) {
          case 1:
            this.groupCodeList = result;
            break;
          case 2:
            this.groupCodeList1 = result;
            break;
          case 3:
            this.groupCodeList2 = result;
            break;
          case 4:
            this.groupCodeList3 = result;
            break;
          case 5:
            this.groupCodeList4 = result;
            break;
          case 6:
            this.groupCodeList5 = result;
            break;

        }
      }
    },

    async _stockBasketAdd() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        await this.stockBasketAdd({
          params: {
            userId: this.user.UserId,
          },
          body: {
            startDate: this.startDate,
            finishDate: this.finishDate,
            description: this.description,
            stockType: this.stockType,
            stockKey: this.stockKey,
            currentType: this.currentType,
            currentKey: this.currentKey,
            valueType1: this.valueType1,
            valueKey1: this.valueKey1,
            valueType2: this.valueType2,
            valueKey2: this.valueKey2,
            isActive: this.isActive,
          },
        });
        await this.$parent._fetchStockBasketList();
        this.dialog = false;
      }
    },
    async _fetchStockBasketSingle() {
      let stockBasketSingleResult = await this.fetchStockBasketSingle({
        params: {
          campaignId: this.stockBasketId,
        },
        body: {},
      });
      if (stockBasketSingleResult) {
        this.startDate = stockBasketSingleResult.startDate;
        this.finishDate = stockBasketSingleResult.finishDate;
        this.description = stockBasketSingleResult.description;
        this.stockType = stockBasketSingleResult.stockType;
        this.stockKey = stockBasketSingleResult.stockKey;
        this.currentType = stockBasketSingleResult.currentType;
        this.currentKey = stockBasketSingleResult.currentKey;
        this.valueType1 = stockBasketSingleResult.valueType1;
        this.valueKey1 = stockBasketSingleResult.valueKey1;
        this.valueType2 = stockBasketSingleResult.valueType2;
        this.valueKey2 = stockBasketSingleResult.valueKey2;
        this.salesPersonCode = stockBasketSingleResult.salesPersonCode;
        this.isActive = stockBasketSingleResult.isActive
      } else {
        this.startDate = null;
        this.finishDate = null;
        this.description = null;
        this.stockType = null;
        this.stockKey = null;
        this.currentType = null;
        this.currentKey = null;
        this.valueType1 = null;
        this.valueKey1 = null;
        this.valueType2 = null;
        this.valueKey2 = null;
        this.salesPersonCode = null;
      }
    },
  },
  watch: {
    stockType:function (newVal){
      this.currentCodesListResult = [];
      switch (newVal) {
        case 1:
          // this._fetchCurrentCodesList(index,value)
          break;
        case 2:
          //  this._fetchCurrentCodesList(index,value)
          break;
        case 3:
          this._fetchStockCodes(newVal-2);
          break;
        case 4:
          this._fetchStockCodes(newVal - 2);
          break;
        case 5:
          this._fetchStockCodes(newVal - 2);
          break;
        case 6:
          this._fetchStockCodes(newVal - 2);
          break;
        case 7:
          this._fetchStockCodes(newVal - 2);
          break;
        case 8:
          this._fetchStockCodes(newVal - 2);
          break;
      }
    },
    dialog: function (newVal) {
      this.$emit("dialogChange", newVal);
      if (newVal) {
        if (this.processType === "new") {
          this.startDate = null;
          this.finishDate = null;
          this.description = null;
          this.stockType = null;
          this.stockKey = null;
          this.currentType = null;
          this.currentKey = null;
          this.valueType1 = 1;
          this.valueKey1 = null;
          this.valueType2 = null;
          this.valueKey2 = null;
          this.salesPersonCode = null;
          this.isActive = true;
        } else if (this.processType === "edit") {
          this._fetchStockBasketSingle();
        }
      }
    },
    showDialog: function (newVal) {
      this.$v.$reset();
      this.dialog = newVal;
    },
    searchStock(newVal) {
      this.stockList = [];
      if (newVal === "" || newVal === null) {
        if (this.searchStockTimeout) clearTimeout(this.searchStockTimeout);
      } else {
        this.searchStockLoading = true;
        if (this.searchStockTimeout) clearTimeout(this.searchStockTimeout);

        this.searchStockTimeout = setTimeout(() => {
          this._fetchStockList();
        }, 1000);
      }
    },
  },
};
</script>
